import React from "react";
import ReactWordcloud from "react-wordcloud";

const TagCloud = props => {
  return (
    <div className={"tagCloudContainer"}>
      <ReactWordcloud
        words={props.words}
        options={props.options}
        callbacks={props.callbacks}
      />
    </div>
  );
};

export default TagCloud;
